<template>
  <div class="row">
    <div class="col-md-6">
      <el-form ref="form" :model="form" label-width="140px">
        <el-form-item label="Master Airway Bill">
            <el-autocomplete
              name="mawb" v-validate="'required'" autofocus
              class="inline-input"
              clearable
              suffix-icon="nc-icon nc-zoom-split"
              v-model="form.mawb"
              :fetch-suggestions="querySearch"
              placeholder="Search HAWB"
              :trigger-on-focus="false"
              @select="handleSelect"
            ></el-autocomplete> <span style="color:#F56C6C;font-size: 12px;" v-if="!isSearchFound"> {{!isSearchFound &&  'Not found MAWB'}}</span>
          <!-- <el-input v-model="form.mawb" name="mawb" v-validate="'required'" autofocus clearable></el-input> -->
          <span class="el-form-item__error">{{ errors.first('mawb') }}</span>
        </el-form-item>
        <el-form-item label="House Airway Bill">
          <el-input v-model="form.hawb" name="hawb" v-validate="'required'" clearable></el-input>
          <span class="el-form-item__error">{{ errors.first('hawb') }}</span>
        </el-form-item>
        <el-form-item label="Status">
          <el-select v-model="form.status" placeholder="select status" name="status" v-validate="'required'" >
            <el-option label="Over" value="Over"></el-option>
            <el-option label="No Show" value="No Show"></el-option>
            <el-option label="Unmanifest" value="Unmanifest"></el-option>
            <el-option label="CAT4" value="CAT4"></el-option>
          </el-select>
          <span class="el-form-item__error">{{ errors.first('status') }}</span>
        </el-form-item>
        <el-form-item label="Reject">
          <el-select v-model="form.rejectCode" placeholder="select reject code" name="rejectCode" >
            <el-option :label="v.code + ' / ' +v.descriptionTH" :value="v.code" v-for="(v, index) in options.rejects" :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Description">
          <el-input
            type="textarea"
            autosize
            placeholder="Description"
            v-model="form.description">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">Create</el-button>
          <el-button @click="reset">Cancel</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>


<script>
import Vue from "vue"
import { Autocomplete } from "element-ui"
import * as _apiParcel from "@/api/parcel"
import * as _apiMAWB from "@/api/mawb"

Vue.use(Autocomplete)

export default {
  data() {
    return {
      inputSearch: '',
      form: {
        mawb: '',
        hawb: '',
        description: '',
        status: '',
        rejectCode: '',
      },
      isSearchFound: true,
      options: {
        rejects: [],
      }
    }
  },
  watch: {
		'form.status': {
			deep: true,
			handler (newVal) {
        console.log(newVal)
        this.getRejectByTopicID(newVal)
			}
		},
  },
  methods: {
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        this.saveNewParcel()
      }).catch(() => {
        this.$notify({
          message: 'Please enter all required information',
          type: 'danger'
        })
      })
    },
    saveNewParcel () {
      this.inputSearch = this.form.mawb
      _apiParcel.newParcelBriefInfo(this.form)
        .then(response => {
          this.$notify({
            message: 'Save Successfully',
            type: 'success'
          })
          this.reset()
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
            type: 'danger'
          })
        });
    },
    reset () {
      this.form.hawb = ''
      this.form.description = ''
      this.form.status = ''
      this.$validator.reset()
      // console.log(this.errors.clear())
    },
    async handleSelect(item) {
      this.form.mawb = item.value
    },
    async querySearch (queryString, cb) {
      try {
        const res = await _apiMAWB.searchMAWB(queryString)
        this.isSearchFound = !!res.data
        cb(res.data ? res.data : [])
      } catch (err) {
        this.$notify({
          message: err,
          type: 'danger'
        })
      }
    },
    async getRejectByTopicID(status) {
      if (!status) {
        return
      }
      try {
        const res = await _apiParcel.getRejectCode(status)
        this.options.rejects = res.data.rejects
      } catch (err) {
        this.$notify({
          message: err,
          type: 'danger'
        })
      }
    }
  }
}
</script>
